(() => {
  const popup = document.querySelector('[data-vf-sale-popup]');
  if (!popup) return;

  const dialog = popup.querySelector('.vf-sale-popup__dialog');
  const closeButtons = popup.querySelectorAll('[data-vf-sale-close]');
  const closeButton = popup.querySelector('.vf-sale-popup__close');
  const storageKey = 'vorfel-1111-popup-dismissed';
  let dismissed = false;

  try {
    dismissed = window.sessionStorage.getItem(storageKey) === '1';
  } catch (error) {}

  if (dismissed) return;

  let previouslyFocused = null;
  const openPopup = () => {
    previouslyFocused = document.activeElement;
    popup.hidden = false;
    requestAnimationFrame(() => {
      popup.classList.add('is-open');
      closeButton?.focus({ preventScroll: true });
    });
  };

  const closePopup = () => {
    popup.classList.remove('is-open');
    popup.hidden = true;
    try {
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {}
    previouslyFocused?.focus?.({ preventScroll: true });
  };

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  document.addEventListener('keydown', (event) => {
    if (popup.hidden) return;
    if (event.key === 'Escape') {
      closePopup();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.setTimeout(openPopup, 1500);
})();
